import { render, staticRenderFns } from "./edite-bsk-league.vue?vue&type=template&id=0f54bfcf&scoped=true"
import script from "./edite-bsk-league.vue?vue&type=script&lang=js"
export * from "./edite-bsk-league.vue?vue&type=script&lang=js"
import style0 from "./edite-bsk-league.vue?vue&type=style&index=0&id=0f54bfcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54bfcf",
  null
  
)

export default component.exports